module.exports = __webpack_public_path__ + "img/adset-icon.a92e23a5.svg";